export default __webpack_public_path__ + "static/media/p1.af38d184.png";